// extracted by mini-css-extract-plugin
module.exports = {"composer":"create-ticket-modal_composer__4slQD","formItemLabel":"create-ticket-modal_formItemLabel__C4zsd","disabled":"create-ticket-modal_disabled__4Xp1E"};